import { hcpAPI } from 'configs/axios';
import { API_URLS } from 'utils/apiUrls';
import { TestCreationReqData } from 'utils/hcp/test/create-test.helper';
import { isAPIUS } from 'utils/storage';

export const fetchTests = (
  params: {
    with_related: boolean;
    with_count: boolean;
    query: string;
    page: number;
    page_size: number;
    sort: string;
    search?: string;
  },
  signal?: AbortSignal | undefined
) => {
  return hcpAPI({
    url: '/tests',
    method: 'GET',
    config: {
      params,
      signal,
    },
  });
};

export const fetchTestById = (testId: string, signal?: AbortSignal | undefined) => {
  const params = {
    with_related: true,
    with_unit: true,
  };
  return hcpAPI({
    url: `/tests/${testId}`,
    method: 'GET',
    config: {
      params,
      signal,
    },
  });
};

export const endTest = (id: string) => {
  return hcpAPI({
    url: `/tests/endtest/${id}`,
    method: 'PATCH',
  });
};

export const updateTest = (
  id: string,
  data: {
    sensor_type: string[];
    number_of_recordings: number;
    diagnostic_nights_needed: number;
    allowed_extensions: number;
  }
) => {
  return hcpAPI({
    url: `/tests/${id}`,
    method: 'PATCH',
    data,
  });
};

export const createTest = (data: TestCreationReqData, customHeaders?: Record<string, string>) => {
  const config = { headers: customHeaders || {} };

  return hcpAPI({
    url: '/tests',
    method: 'POST',
    data,
    config,
  });
};

export const archiveTest = (id: string) => {
  return hcpAPI({
    url: `/tests/archive/${id}`,
    method: 'PATCH',
  });
};

export const restoreTest = (id: string) => {
  return hcpAPI({
    url: `/tests/unarchive/${id}`,
    method: 'PATCH',
  });
};

export const deleteTest = (id: string) => {
  let url;
  if (isAPIUS()) {
    url = `${API_URLS.HARD_DELETE}/${id}`;
  } else {
    url = `${API_URLS.TESTS}/${id}`;
  }
  return hcpAPI({
    url,
    method: 'DELETE',
  });
};
